import 'babel-polyfill';
import EventEmitter from 'events'
import { loadAll, config, log, loadNpmDependencies, cloneRepositoryList, cloneSkeleton, load } from './Organized'
import minimist from 'minimist'
import fs from 'fs'
import pluginTemplate from './templates/plugin.template'
import npmTemplate from './templates/npm.template'
import packagejs from '../package.json'

const event          = new EventEmitter()
const dir            = process.cwd()
const argv           = minimist(process.argv.slice(2));
const { danger, success } = log

const beforeLoad = async (file) => {

    config.loaders = file;

    let pkgJSON = null;

    try{
        pkgJSON = require(`${process.cwd()}/package.json`);
        load('packageJSON', pkgJSON)
    }
    catch (e) {
        console.log('Não foi possível carregar o package.json')
    }

    await loadAll([`${file.root}/${file.plugins}/*/main.js`], async () => {
        const BeforeLoad = require(`${file.root}/${file.before}`);

        if(BeforeLoad.hasOwnProperty('default'))
            await BeforeLoad.default();
        else
            await BeforeLoad();

        event.emit('loadSystem', file);
    });
}

const loadSystem = async (file) => {
    const Main = require(`${file.root}/${file.main}`);

    if(Main.hasOwnProperty('default'))
        await Main.default();
    else
        await Main();

    event.emit('afterLoad', file);
}

const afterLoad = async (file) => {
    const AfterLoad = require(`${file.root}/${file.after}`);

    if(AfterLoad.hasOwnProperty('default'))
        await AfterLoad.default();
    else
        await AfterLoad();
}

const loadCliFunc = async (dir) => {
    const cliFunc       = argv['_'].hasOwnProperty(0) ? argv['_'][0] : false;
    const generatorFunc = argv['_'].hasOwnProperty(1) ? argv['_'][1] : false;
    const cliValue      = argv['_'].hasOwnProperty(2) ? argv['_'][2] : false;

    let pkgJSON = null;

    try{
        pkgJSON = require(`${process.cwd()}/package.json`);
        load('packageJSON', pkgJSON);
    } catch (e) {

    }

    if((argv.hasOwnProperty('v') && argv.v) || (argv.hasOwnProperty('version') && argv.version)){
        success(`v${packagejs.version}`)
    }
    else if(cliFunc && (cliFunc == 'install' || cliFunc == 'i')){
        log.info('Instalando dependências');

        let list = pkgJSON
        let listOfRepositories = []

        for(let i in list.dekDependencies)
            listOfRepositories.push([i, list.dekDependencies[i]])

        cloneRepositoryList(listOfRepositories, () => {
            loadNpmDependencies([`${process.cwd()}/${pkgJSON.dekCLI.plugins}/*/npm.js`]);
        });
    }
    else if(cliFunc && cliFunc == 'init'){
        if(generatorFunc)
            cloneSkeleton(generatorFunc);
        else
            cloneSkeleton();
    }
    else if(cliFunc && cliFunc == 'new' && generatorFunc == 'plugin'){
        let pluginName = cliValue
        let pluginsDir = `${process.cwd()}/${pkgJSON.dekCLI.plugins}`

        if(!fs.existsSync(pluginsDir))
            fs.mkdirSync(pluginsDir)

        if(!fs.existsSync(`${pluginsDir}/${pluginName}`)){

            try{
                fs.mkdirSync(`${pluginsDir}/${pluginName}`)
                fs.writeFileSync(`${pluginsDir}/${pluginName}/main.js`, pluginTemplate(pluginName));
                fs.writeFileSync(`${pluginsDir}/${pluginName}/npm.js`,  npmTemplate());
                success(`[DEK] Plugin ${pluginName} criado com sucesso`)
            }
            catch(e){
                danger(`[DEK] Já existe um plugin criado com esse nome ${e}`)
            }

        }else{
            danger('[DEK] Já existe um plugin criado com esse nome')
        }

    }
    else{
        let pluginsDir = `${process.cwd()}/${pkgJSON.dekCLI.pluginsBuild}`;

        loadAll([`${pluginsDir}/*/main.js`], async (listOfFunctions) => {
            if(cliFunc && cliFunc == 'new'){
                if(listOfFunctions['generator'].hasOwnProperty(generatorFunc)){
                    await listOfFunctions['generator'][generatorFunc](argv);
                }
                else{
                    console.log('');
                    danger(`Generator ${generatorFunc} não existe`);
                }
            }
            else if(cliFunc && listOfFunctions['cli'].hasOwnProperty(cliFunc)){
                await listOfFunctions['cli'][cliFunc](argv);
            }
            else{
                console.log('');
                danger(`CLI ${cliFunc} não existe`);
            }
        });
    }
}

event.on('beforeLoad', beforeLoad);
event.on('loadSystem', loadSystem);
event.on('afterLoad', afterLoad);
event.on('loadCli', loadCliFunc);

export default event;
